import {COLUMN_TYPES} from "./constants";
import {ODATA_COLUMN_TYPES} from "../../utils/odata";

// Helpers
export const isGeneric = column => column.dimensionType === COLUMN_TYPES.generic;
export const isMeasure = column => column.dimensionType === COLUMN_TYPES.measure;
export const isCoded = column => column.dimensionType === COLUMN_TYPES.coded;

const timeTypesWithFormat = [
  ODATA_COLUMN_TYPES.dateTime,
  ODATA_COLUMN_TYPES.day,
  ODATA_COLUMN_TYPES.time,
  ODATA_COLUMN_TYPES.month,
  ODATA_COLUMN_TYPES.year
];
export const isTimeColumnWithFormat = column =>
  isGeneric(column) && timeTypesWithFormat.includes(column.genericDimensionType);

export const isCoordinates = column =>
  isGeneric(column) &&
  (column.genericDimensionType === ODATA_COLUMN_TYPES.lat || column.genericDimensionType === ODATA_COLUMN_TYPES.lon);

export const parseColumnDefinitions = columns => {
  return columns.map(column => ({
    ...column,
    measureDigits: column.measureDigits > 4 ? 4 : column.measureDigits,
    formatDate: isTimeColumnWithFormat(column) ? column.format : null,
    formatCoordinates: isCoordinates(column) ? column.format : null
  }));
};

export const serializeColumnDefinitions = columns => {
  let columnDefinitions = [];

  columns.forEach(column => {
    if (column.import) {
      let format = null;
      if (isTimeColumnWithFormat(column)) format = column.formatDate;
      if (isCoordinates(column)) format = column.formatCoordinates;

      columnDefinitions.push({...column, format: format});
    }
  });

  return columnDefinitions;
};
